// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"c9632f77","460":"8eb05bc5","504":"966c8346","508":"60a4fdfb","724":"207b7416","810":"ba53d179","818":"9a1a987c","962":"f5c8645c"}[chunkId] + ".chunk.js";
};